/**
 * UX-B1 (#295) — QueryClient กลางของแอป (ย้ายการสร้างจาก main.tsx มาไว้ที่เดียวเพื่อเทสต์ได้)
 * - default เหมือนเดิม: query ไม่ retry error จาก API · mutation ไม่ retry
 * - MutationCache.onError: mutation ที่ fail และหน้าไม่ได้จัดการเอง (ไม่มี meta MUTATION_ERROR_HANDLED_META)
 *   → ส่งเข้า toast กลาง (MutationErrorToaster) จุดเดียว พร้อม request reference ถ้ามี —
 *   หน้าที่ render error เอง (เช่น ใน Modal/AdminTable ผ่าน useAdminCrud errorMode "local") ติด meta ไว้เพื่อไม่ฉายซ้ำ
 */
import { MutationCache, QueryClient } from "@tanstack/react-query";
import { notifyMutationError } from "../components/MutationErrorToaster";
import { isApiError } from "./api";

/** meta ที่ useAdminCrud(errorMode: "local") ติดให้ mutation — บอกว่าหน้านี้แสดง error เองแล้ว */
export const MUTATION_ERROR_HANDLED_META = "uwuMutationErrorHandled";

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (count, err) => !isApiError(err) && count < 2, // ไม่ retry error จาก API (401/403/404/409)
        refetchOnWindowFocus: true,
      },
      mutations: { retry: false },
    },
    mutationCache: new MutationCache({
      onError: (error, _variables, _onMutateResult, mutation) => {
        if (mutation.meta?.[MUTATION_ERROR_HANDLED_META]) return;
        notifyMutationError(error);
      },
    }),
  });
}
